var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { SelectEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
function isValidSelected(value) {
    return Array.isArray(value);
}
class SelectableIteratorAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onSelect = new SelectEventListener();
    }
    getData() {
        return this.state.data;
    }
    setData(data) {
        if (Array.isArray(data)) {
            this.setState({ data });
        }
        throw new Error('The informed value is not valid.');
    }
    isMultiSelect() {
        return this.state.multiselect;
    }
    getPrimaryKey() {
        return this.state.primaryKey;
    }
    setPrimaryKey(primaryKey) {
        this.setState({ primaryKey });
    }
    getSelected() {
        return this.state.selected;
    }
    setSelected(selected) {
        if (isValidSelected(selected)) {
            this.setState({ selected });
        }
        throw new Error('The informed value is not valid. Please check the Selected type.');
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], SelectableIteratorAPI.prototype, "onSelect", void 0);
export { SelectableIteratorAPI, };
//# sourceMappingURL=selectable-iterator-api.js.map